import React from 'react';
import { SectionHeading } from './SectionHeading';
import { Reveal } from './Reveal';
import { purchaseSteps } from '../data/landing';
export function HowToGetSection() {
  return <section className="bg-slate-100 py-16 sm:py-24" data-id="element-137" data-mp="kkqf9tv0cxim">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-138" data-mp="kl9ngiuuw7jg">
        <SectionHeading title="¿Cómo funciona?" subtitle="De la compra a tu primera cotización PDF en menos de 10 minutos." data-id="element-139" data-mp="fmf51i0swkzv" />
        <ol className="relative mt-12 grid gap-6 lg:grid-cols-4 lg:gap-6" data-id="element-140" data-mp="1d8ckt7nsqc84">
          <span aria-hidden="true" className="absolute left-6 top-6 hidden h-0.5 w-[calc(100%-3rem)] bg-slate-300 lg:block" data-id="element-141" data-mp="18ab0kjemw6v2" />
          {purchaseSteps.map((step, i) => <Reveal as="li" key={step.title} delay={i * 0.05} data-id="element-142" data-mp="z9wc5b6dibnc" data-mpi={i}>
              <div className="relative flex items-center gap-4 lg:flex-col lg:items-start" data-id="element-143" data-mp="z9cy45jug7el">
                <span className="relative grid h-12 w-12 shrink-0 place-items-center rounded-full bg-primary text-lg font-black text-white ring-8 ring-slate-100" data-id="element-144" data-mp="3o3a04bbcx13e">
                  {i + 1}
                </span>
                <p className="text-base font-semibold leading-snug text-ink sm:text-lg" data-id="element-145" data-mp="23ovaizw2zb9f">{step.title}</p>
              </div>
            </Reveal>)}
        </ol>
      </div>
    </section>;
}